export const isDev = process.env.NODE_ENV !== 'production'
export const isBrowser = typeof window !== 'undefined'
export const canPrint = isDev && isBrowser

const logFunc = (message?: any, ...optionalParams: any[]) => {
	if (canPrint && message !== false) console.log(message, ...optionalParams)
}

logFunc.ok = (message?: any, ...optionalParams: any[]) => {
	if (canPrint && message !== false)
		console.log(
			`%c${message}`,
			`color:#FFF; background-color:#0a960a; padding: 4px;`,
			...optionalParams
		)
}

logFunc.err = (message?: any, ...optionalParams: any[]) => {
	if (canPrint && message !== false)
		console.log(
			`%cAPI${message}`,
			`color:#FFF; background-color:#a80505; padding: 4px;`,
			...optionalParams
		)
}

logFunc.warn = (message?: any, ...optionalParams: any[]) => {
	if (canPrint && message !== false)
		console.log(
			`%cAPI${message}`,
			`color:#FFF; background-color:#af4803; padding: 4px;`,
			...optionalParams
		)
}

logFunc.info = (message?: any, ...optionalParams: any[]) => {
	if (canPrint && message !== false)
		console.log(
			`%cAPI${message}`,
			`color:#FFF; background-color:#a5a5a5; padding: 4px;`,
			...optionalParams
		)
}

export const log = logFunc
